interface SEOMeta {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  ogTitle?: string;
  ogDescription?: string;
}

export default function useSEOMeta(meta: SEOMeta) {
  if (typeof document === 'undefined') return;

  document.title = meta.title;

  const setMeta = (name: string, content: string, isProperty = false) => {
    const attr = isProperty ? 'property' : 'name';
    let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attr, name);
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  };

  setMeta('description', meta.description);
  setMeta('keywords', meta.keywords);

  const canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (canonical) {
    canonical.setAttribute('href', meta.canonicalUrl);
  } else {
    const link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', meta.canonicalUrl);
    document.head.appendChild(link);
  }

  setMeta('og:type', meta.ogType || 'website', true);
  setMeta('og:title', meta.ogTitle || meta.title, true);
  setMeta('og:description', meta.ogDescription || meta.description, true);
  setMeta('og:url', meta.canonicalUrl, true);
  if (meta.ogImage) {
    setMeta('og:image', meta.ogImage, true);
  }

  setMeta('twitter:card', 'summary_large_image');
  setMeta('twitter:title', meta.ogTitle || meta.title);
  setMeta('twitter:description', meta.ogDescription || meta.description);
  if (meta.ogImage) {
    setMeta('twitter:image', meta.ogImage);
  }
}

export { type SEOMeta };